import React, { useState, useEffect } from 'react';

export function TrackOrderPage() {
  const initialId = new URLSearchParams(window.location.search).get('id') || '';

  const [inputId, setInputId] = useState(initialId);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const STATUS_INFO = {
    pending:   { icon: '⏳', label: 'Pending',   color: '#e67e22', msg: 'We have received your order and are reviewing it. We\'ll confirm it shortly.' },
    confirmed: { icon: '✅', label: 'Confirmed',  color: '#2980b9', msg: 'Your order is confirmed and is being prepared for dispatch.' },
    shipped:   { icon: '🚚', label: 'Shipped',    color: '#8e44ad', msg: 'Your order is on its way! Expect delivery in 3–5 business days.' },
    delivered: { icon: '🎉', label: 'Delivered',  color: '#27ae60', msg: 'Your order has been delivered. We hope you enjoy your Kiane treats!' },
    cancelled: { icon: '❌', label: 'Cancelled',  color: '#c0392b', msg: 'This order has been cancelled. Reach out to us if you have any questions.' },
  };

  useEffect(() => {
    if (initialId) doFetch(initialId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function doFetch(id) {
    setLoading(true); setError(''); setOrder(null);
    try {
      const res = await fetch(`/api/get-order?id=${encodeURIComponent(id)}`);
      const data = await res.json();
      if (!res.ok || !data.id) setError('Order not found. Please check your Order ID and try again.');
      else setOrder(data);
    } catch (err) { setError(`Network error: ${err.message}. Make sure the server is running.`); }
    setLoading(false);
  }

  function handleTrack(e) {
    e.preventDefault();
    const id = inputId.trim();
    if (!id) return;
    window.history.replaceState(null, '', `/track?id=${encodeURIComponent(id)}`);
    doFetch(id);
  }

  const info = order ? (STATUS_INFO[order.status] || { icon: '📦', label: order.status, color: '#888', msg: '' }) : null;

  return (
    <div className="track-page">
      <div className="track-page-nav">
        <a href="/" className="track-page-logo-link">
          <img src="/logo.webp" alt="Kiane Foods" className="track-page-logo" />
        </a>
      </div>
      <div className="track-page-body">
        <div className="track-page-card">
          <span className="track-icon">📦</span>
          <h1>Track Your Order</h1>
          <p>Enter your Order ID to check the latest delivery status.</p>

          <form onSubmit={handleTrack} className="track-form">
            <input
              type="text"
              className="track-input"
              placeholder="Paste your Order ID here…"
              value={inputId}
              onChange={e => { setInputId(e.target.value); setError(''); setOrder(null); }}
            />
            <button type="submit" className="btn-primary track-btn" disabled={loading || !inputId.trim()}>
              {loading ? 'Tracking…' : 'Track'}
            </button>
          </form>

          {error && <p className="form-error" style={{ marginTop: '10px' }}>{error}</p>}

          {order && info && (
            <div className="track-result">
              <div className="track-status-badge" style={{ background: info.color }}>
                {info.icon} {info.label}
              </div>
              <p className="track-status-msg">{info.msg}</p>
              <div className="order-details-box">
                <div className="order-detail-row"><span>Name</span><span>{order.customer_name}</span></div>
                <div className="order-detail-row"><span>Order Date</span><span>{new Date(order.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</span></div>
                <div className="order-detail-row"><span>Items</span><span>{(order.items || []).length} item(s)</span></div>
                <div className="order-detail-row"><span>Amount</span><strong>₹{order.total}</strong></div>
                <div className="order-detail-row"><span>Delivery To</span><span>{[order.city, order.pincode].filter(Boolean).join(', ') || '—'}</span></div>
              </div>
            </div>
          )}

          <a href="/" className="track-page-back">← Back to Kiane Foods</a>
        </div>
      </div>
    </div>
  );
}
